import React, { useRef } from "react";
import "./Testimonials.scss";
import { useTranslation } from "react-i18next";
import Swiper from "react-id-swiper";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import Fade from "@successtar/react-reveal/Fade";
import testimonials from "./Testimonials.json";

// Activer les modules Swiper
SwiperCore.use([Autoplay, Navigation, Pagination]);

const Testimonials = () => {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  
  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };
  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const swiperParams = {
    loop: true,
    spaceBetween: 40,
    centeredSlides: true,
    slidesPerView: 1,
    grabCursor: true,

    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    breakpoints: {
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
  };


  const getRatingPercent = (rating) => (rating / 5) * 100;

  const Stars = ({ rating }) => {
    const percent = getRatingPercent(rating);

    return (
      <div className="stars-outer">
        <div className="stars-inner" style={{ width: `${percent}%` }}></div>
      </div>
    );
  };

  return (
    <section className="container section" id="testimonials">
      <Fade bottom>
        <span className="title title--overhead js-lines">Testimonials</span>
        <h1 className="title title--h1 js-lines">
          What they says about us
        </h1>
      </Fade>

      <Fade bottom>
        <div className="swiper testimonials-swiper">
          <Swiper {...swiperParams} ref={swiperRef}>
            {testimonials.map((t, index) => (
                <div className="swiper-slide" key={index}>
                  <article className="testimonial-card">
                    <header className="testimonial-header">
                      <div className="avatar-wrapper">
                        <img
                          src={t.avatar}
                          alt={t.name}
                          className="avatar"
                        />
                        <span className="avatar-badge">
                          {t.badge}
                        </span>
                      </div>
                      <div>
                        <Stars rating={t.rating} />
                      </div>
                    </header>

                    <p className="testimonial-text">
                      {t.text}
                    </p>

                    <footer className="testimonial-footer">
                      <span className="client-name">{t.name}</span>
                      <span className="client-date">{t.date}</span>
                    </footer>
                  </article>
                </div>
              ))}
          </Swiper>

          {/* <!-- Navigation --> */}
          <div className="swiper-button-prev" onClick={goPrev}></div>
          <div className="swiper-button-next" onClick={goNext}></div>

          {/* <!-- Pagination --> */}
          <div className="swiper-pagination"></div>
        </div>
      </Fade>
    </section>
  );
};

export default Testimonials;
